import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { siteBoxDocumentsKeys } from '../siteBoxDocumentsKeys'
import { SiteBoxDocumentConfig } from '@core/entities/SiteBoxDocumentConfig'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { RequestTypes } from '../requestTypes'
import { foldersKeys } from '../../folders/foldersKeys'

export const useProcessSiteBoxConfiguration = (
  options?: UseMutationOptions<
    SiteBoxDocumentConfig,
    RequestErrorType,
    RequestTypes['processSiteBoxConfiguration']
  >,
) => {
  const queryClient = useQueryClient()

  return useMutation({
    ...siteBoxDocumentsKeys.processSiteBoxConfiguration,
    ...options,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({
        queryKey: siteBoxDocumentsKeys._def,
      })
      queryClient.invalidateQueries({
        queryKey: foldersKeys._def,
      })
    },
  })
}
